import axios, { AxiosError } from 'axios'
import { useQuery } from 'react-query'
import { getAppConfigSetting } from '../utils'
import { CASH_BALANCES_API } from './constants'
import { CashBalancesAvailableResponsePayload } from '../types/api-response/CashBalancesPayload'
import queryKeys from './queryKeys'

const buildApiUrl = (accountNumber: string): string => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${CASH_BALANCES_API}/available/${accountNumber}`
}

export const useGetCashBalancesAvailable = (accountNumber: string) => {
  const getCashBalancesAvailableUrl = buildApiUrl(accountNumber)

  const getCashBalancesAvailable = async (): Promise<CashBalancesAvailableResponsePayload> => {
    const { data } = await axios.get(getCashBalancesAvailableUrl, { withCredentials: true })
    return data as CashBalancesAvailableResponsePayload
  }

  return useQuery<CashBalancesAvailableResponsePayload, AxiosError>(
    [queryKeys.cashBalances, accountNumber],
    getCashBalancesAvailable,
    {
      // The query will not execute until the accountNumber exists
      enabled: !!accountNumber
    }
  )
}
